import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import _ from 'lodash';
import { styles } from './itemHeaderStyles';

export type InfoItem = {
  icon?: ReactNode;
  content: ReactNode;
};

type ItemHeaderInfoProps = {
  infoItems?: InfoItem[];
};

export default function ItemHeaderInfo({ infoItems }: ItemHeaderInfoProps) {
  if (!infoItems?.length) return null;

  return (
    <Box sx={styles.secondaryRow}>
      {_.map(infoItems, (item, index) => (
        <Box key={index} sx={styles.secondaryItem}>
          {item.icon}
          <span>{item.content}</span>
        </Box>
      ))}
    </Box>
  );
}
